import React, { useState } from 'react';
import { Button } from "react-bootstrap";

function RefreshButton({ onClick, onTimeout, timeout = 60000, ...rest}) {
    const [buttonText, setButtonText] = useState('Refresh Address Match');
    const [loading, setLoading] = useState(false);

    const handleClick = () => {
        if (!loading && onClick) {
            onClick();
            setButtonText('Loading...');
            setLoading(true);

            // This timeout is a hack because the API Gateway times out after 29 seconds, so we reload the integrations after the timeout period.
            // This also means that refreshed integrations will not show if creating them takes more than {timeout} milliseconds.
            // Sorry to whoever has to fix this in the future.
            setTimeout(() => {
                if (onTimeout) {
                    onTimeout();
                }

                setButtonText('Refresh Address Match');
                setLoading(false);
            }, timeout);
        }
    };

    return (
        <Button onClick={handleClick} disabled={loading} {...rest}>
            {buttonText}
        </Button>
    );
}

export default RefreshButton;
